import { useState, useEffect, useCallback, useRef } from "react";

import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";

import Loader from "../common/loader";
import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";

import { format } from "date-fns";
import { getStopsListApi, deleteStopsApi, downloadStopTemplateApi, downloadBase64File } from "./stops-api";
import { useGlobal } from "../../GlobalContext";
import profileIcon from "../../assets/png/profile-ic.png";
import emailIcon from "../../assets/svg/email_ic.svg";
import phoneIcon from "../../assets/svg/phone_ic.svg";
import editIcon from "../../assets/svg/edit_ic.svg";
import deleteIcon from "../../assets/svg/delete_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import Sidebar from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import customerIcon from "../../assets/svg/customer_active_ic.svg";
import StopsExcelUploadModal from "./StopsExcelUploadModal";
import dateIcon from "../../assets/svg/date_ic.svg";
import ProfileImageModal from "../common/ProfileImageModal";

export const StopListing = () => {
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Stops" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  // variable initial
  const isFirstRender = useRef(true);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [productSelect, setProductSelect] = useState(null);
  const [vendorSelect, setVendorSelect] = useState(null);

  const [active, setActive] = useState("grid");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stageOption, setStageOption] = useState([
    { value: "", label: "All" },
    { value: "Delivered", label: "Delivered" },
    { value: "Partially delivered", label: "Partially delivered" },
    { value: "Completed", label: "Completed" },
  ]);
  const [stageListOption, setListStageOption] = useState([]);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);
  const [stopsList, setStopsList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  // handle
  const handleSelectProduct = (option) => {
    console.log("Selected option:", option);
    setProductSelect(option);
  };

  const [customerSelect, setCustomerSelect] = useState(null);
  const [locationSelect, setLocationSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState(null);
  const handleSelectCustomer = (option) => {
    console.log("Selected option:", option);
    setCustomerSelect(option);
  };
  const handleClearCustomer = () => {
    setCustomerSelect(null);
  };

  const handleSelectLocation = (option) => {
    setLocationSelect(option);
  };
  const handleClearLocation = () => {
    setLocationSelect(null);
  };

  const handleSelectStatus = (option) => {
    console.log("Selected option:", option);
    setStatusSelect(option);
  };

  const handleClearStatus = () => {
    setStatusSelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  // useEffect

  useEffect(() => {
    getStopsList();
  }, [itemsPerPage, itemOffset, search, selectedSortby, statusSelect, customerSelect, locationSelect, startDateSave, endDateSave]);

  // Api

  const getStopsList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["Created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      status: statusSelect?.value ?? "",
      customer_id: customerSelect?.value ?? "",
      location_id: locationSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getStopsListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.totalcount ?? 0);
        setPageCount(response.data.totalpages ?? 0);
        setStopsList(response.data.stops ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteStopsApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getStopsList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadTemplate = async () => {
    setIsLoading(true);
    try {
      const res = await downloadStopTemplateApi();

      if (!res || !res.data) {
        throw new Error("No response from server");
      }

      if (res.data.success === false) {
        setSnackbarMessage(res.data.message || "Failed to download template");
        setSnackbarStatus(false);
        handleSnackbarShow();
        return;
      }

      let filename = "stops_template_" + new Date().toISOString() + ".xlsx";

      downloadBase64File(res.data.base64, filename);

      setSnackbarMessage("Template downloaded successfully");
      setSnackbarStatus(true);
      handleSnackbarShow();
    } catch (err) {
      console.error("Error downloading template:", err);
      setSnackbarMessage(err.message || "Error downloading template");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <LoaderModal show={isLoading} />
      <StopsExcelUploadModal
        type={"Stop"}
        show={showExcelUploadModal}
        onHide={() => setShowExcelUploadModal(false)}
        onUploadSuccess={() => {
          getStopsList();
          setSnackbarMessage("Stops imported successfully");
          setSnackbarStatus(true);
          handleSnackbarShow();
        }}
      />
      <DeleteModal
        title={"stops"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Stops" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  " style={{ width: "calc(100vw - 80px)" }}>
          <Navbar pageTitle="Stops" /> {/*  <Navbar pageTitle="Receipt" /> */}
          <div className="bg-half-white p-2  scroll-hidden" style={{ height: "calc(100vh - 56px)" }}>
            <div className=" p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* Left: Heading */}
                <div className="my-heading fs-24 fw-600" style={{ color: "#9299A7" }}>
                  Stops : {totalCount}
                </div>

                {/* Right: Controls */}
                <div className="d-flex flex-wrap gap-3">
                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor" value={search || ""} onChange={(e) => setSearch(e.target.value)} />
                  </div>

                  {/* Add New Vendor */}

                  {checkPermission("create_permission") && (
                    <div
                      className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2  px-3"
                      onClick={() => navigate("/stops/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                      </div>

                      <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                        New Stop
                      </div>
                    </div>
                  )}

                  {/* Excel Upload Button */}
                  <div className="cursor-pointer d-flex align-items-center justify-content-center gap-2 px-3" style={{ height: "40px" }}>
                    {checkPermission("create_permission") && (
                      <div
                        className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                        style={{
                          height: "40px",
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #3469E7",
                          color: "#3469E7",
                        }}
                        onClick={handleDownloadTemplate}
                      >
                        <DownloadIc />
                        <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                          Template
                        </div>
                      </div>
                    )}

                    {checkPermission("create_permission") && (
                      <div
                        className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                        onClick={() => setShowExcelUploadModal(true)}
                        style={{
                          height: "40px",
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #3469E7",
                          color: "#3469E7",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <ImportIc />
                        </div>
                        <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                          Import
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Import */}
                  {/* <div className="my-import d-flex align-items-center justify-content-center gap-2">
                  <ImportIc />
                  <div style={{ paddingBottom: "4px" }}>Import</div>
                </div> */}
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex flex-wrap justify-content-start gap-2">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">{selectedSortby.label}</span>

                          {/* <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span> */}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown apiUrl={`${apiUrl}customer/autosuggestion`} placeholder="Customer" value={customerSelect} onSelect={handleSelectCustomer} handleClear={handleClearCustomer} />
                  </div>
                  <div>
                    <SearchableDropdown apiUrl={`${apiUrl}get_locations`} placeholder="Location" value={locationSelect} onSelect={handleSelectLocation} handleClear={handleClearLocation} />
                  </div>
                  <div>
                    <SearchableDropdown apiUrl={`${apiUrl}stops/status`} placeholder="Status" value={statusSelect} onSelect={handleSelectStatus} handleClear={handleClearStatus} />
                  </div>
                  {/* <div>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          backgroundColor: "white",
                        }}
                      >
                        
                        <span className="fs-12 fw-400 textGrey">Status :</span>

                       
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {statusSelect?.label || "Select"}
                          </span>

                          
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {stageOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={() => setStatusSelect(option)}
                            active={statusSelect?.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div> */}
                  {/* <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_parts`}
                      placeholder="Product"
                      value={productSelect}
                      onSelect={handleSelectProduct}
                      handleClear={handleClearProduct}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_pr_stages`}
                      placeholder="Status"
                      value={statusSelect}
                      onSelect={handleSelectStatus}
                      handleClear={handleClearStatus}
                    />
                  </div> */}
                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "8px",
                      height: "32px",
                      border: "1px solid #EBEBEB",

                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span className="dropdown-text1 ps-1 pb-1">
                      {" "}
                      <DateRangePicker onChange={handleDateChange} startDate={startDate} endDate={endDate} />
                    </span>
                  </div>{" "}
                  {/* <div
                  className="d-flex align-items-center px-1"
                  style={{
                    borderRadius: "12px",
                    border: "1px solid #EBEBEB",

                    backgroundColor: "white",
                  }}
                >
                  <span className="fs-12 fw-400 textGrey">Date :</span>
                  <span className="dropdown-text textPurple">
                    {" "}
                    <DateRangePicker onChange={handleDateChange} />
                  </span>
                </div>
                 */}
                  <div
                    className="cursor-pointer ms-1 fs-12 fw-400 textGrey text-decoration-underline d-flex align-items-center justify-content-center"
                    style={{ height: "30px" }}
                    onClick={() => {
                      setCustomerSelect(null);
                      setLocationSelect(null);
                      setStatusSelect(null);
                      setStartDateSave(null);
                      setEndDateSave(null);
                      setStartDate(null);
                      setEndDate(null);
                    }}
                  >
                    Reset Filters
                  </div>
                </div>

                <div
                  className="rounded-3 toggleBg d-flex mt-2"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#FFFFFF", // toggle background
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  {/*  Excel upload */}
                  <div
                    onClick={() => setActive("list")}
                    className={`d-flex align-items-center justify-content-center rounded-3  ${active === "list" ? "bg-primary1" : ""}`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "list" ? <ListView style={iconStyle} /> : <SelectList style={iconStyle} />}
                  </div>

                  <div
                    onClick={() => setActive("grid")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${active === "grid" ? "bg-primary1" : ""}`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "grid" ? <SelectGrid style={iconStyle} /> : <EmailView style={iconStyle} />}
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="bg-white rounded-4 w-100 p-3">
                <div
                  style={{
                    display: "flex",
                    flex: "10",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingTop: "16px",
                    height: "40px",
                    backgroundColor: "#F2F2F2",
                  }}
                  className="head3 w-100 justify-content-center align-items-center"
                >
                  {/* <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleChange}
                                style={{ marginRight: "8px", marginBottom: "14px" }}
                              /> */}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    CODE
                  </p>
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    CUSTOMER NAME
                  </p>
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    MOBILE NO.
                  </p>
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    EMAIL
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    FROM ADDRESS
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    TO ADDRESS
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    DATE
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor">
                    Status
                  </p>{" "}
                </div>
                <div>
                  <div>
                    {(stopsList ?? []).map((item, index) => (
                      <div
                        key={item.id ?? index}
                        style={{
                          display: "flex",
                          flex: "10",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                          borderBottom: "1px solid #D4DDE7",
                          cursor: "pointer",
                          height: "44px",
                          position: "relative", // ⭐ Fixed positioning
                          overflow: "hidden", // ⭐ Prevents floating outside row
                          transition: "background-color .2s ease",
                        }}
                        onClick={() => {
                          if (checkPermission("view_permission")) {
                            navigate("/stops/view", { state: { id: item.id } });
                          }
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        className="head3 w-100 justify-content-center align-items-center"
                      >
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.stop_code}
                        >
                          {item.stop_code ?? "---"}
                        </p>
                        {/* CUSTOMER NAME */}
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.customer_name}
                        >
                          {item.customer_name ?? "---"}
                        </p>

                        {/* MOBILE */}
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.mobilenumber}
                        >
                          {item.mobilenumber ?? "---"}
                        </p>

                        {/* EMAIL */}
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.email}
                        >
                          {item.email ?? "---"}
                        </p>

                        {/* FROM ADDRESS */}
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.from_address}
                        >
                          {item.from_address ?? "---"}
                        </p>

                        {/* TO ADDRESS */}
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.to_address}
                        >
                          {item.to_address ?? "-"}
                        </p>

                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.created_date}
                        >
                          {item.created_date ?? "-"}
                        </p>

                        {/* STATUS */}
                        <p
                          className="fs-13 fw-500 textcolor"
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            marginTop: "16px",
                          }}
                          title={item.status}
                        >
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "3px",
                              display: "inline-block",
                              background: "#F4C542",
                              marginRight: "6px",
                            }}
                          ></span>
                          {item.status ?? "---"}
                        </p>

                        {/* ACTION BUTTONS ON HOVER */}
                        {hoveredIndex === index && (
                          <div
                            style={{
                              position: "absolute",
                              right: "35px",
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              {/* EDIT */}
                              {checkPermission("edit_permission") && item.status === "Created" && (
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/stops/create", {
                                      state: { id: item.id },
                                    });
                                  }}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "100px",
                                    background: "#FFFFFF",
                                    border: "0.8px solid #E5E5E5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img src={editIcon} alt="edit" />
                                </div>
                              )}

                              {/* DELETE */}
                              {checkPermission("delete_permission") && item.status === "Created" && (
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleteId(item.id);
                                  }}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "100px",
                                    background: "#FFFFFF",
                                    border: "0.8px solid #E5E5E5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    marginLeft: "16px",
                                  }}
                                >
                                  <img src={deleteIcon} alt="delete" />
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {active === "grid" &&
              stopsList.map((stop, index) => (
                <div
                  key={index}
                  className="bg-white rounded-4  d-flex align-items-center justify-content-between   business-card w-100 p-3 mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("view_permission")) {
                      navigate("/stops/view", {
                        state: { id: stop.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex col-3">
                    <div
                      className="profile-wrapper"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProfile(stop.profile && stop.profile !== "" ? stop.profile : customerIcon);
                        setShowProfilePopup(true);
                      }}
                    >
                      <img key={index} src={stop.profile && stop.profile !== "" ? stop.profile : customerIcon} alt="Profile" className="profile-img" style={{ width: "56px", height: "48px", borderRadius: "50%" }} />{" "}
                    </div>
                    <div className="d-flex flex-column align-items-start justify-content-center gap-2 ps-3">
                      <div className="textcolor fs-16 fw-600 ">{stop.stop_code ?? "-"}</div>
                      <div className="textcolor fs-14 fw-600 ">{stop.customer_name ?? "-"}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      height: "28px",
                      width: "1px",
                      backgroundColor: "#EBEBEB",
                    }}
                  ></div>
                  <div className="col-2 ps-3  d-flex flex-column align-items-start">
                    {/*  <div className="fs-12 fw-600 cardTextGrey">MOBILE NO.</div> */}
                    {stop.mobilenumber !== null && stop.mobilenumber !== "" && (
                      <div className="fs-14 fw-400 textcolor mt-1 d-flex align-items-center justify-content-start">
                        <img src={phoneIcon} alt="phone" /> <span className="ms-1">{stop.mobilenumber ?? "-"}</span>
                      </div>
                    )}
                    {stop.email !== null && stop.email !== "" && (
                      <div className="mt-2 d-flex gap-2  align-items-center">
                        <img src={emailIcon} alt="email" /> <span className="textcolor fs-14 fw-400">{stop.email ?? "-"}</span>{" "}
                      </div>
                    )}
                    <div className="mt-2 fs-14 fw-400 textcolor mt-1 d-flex align-items-center justify-content-start">
                      <img src={dateIcon} alt="date" /> <span className="ms-1">{stop.created_date ?? "-"}</span>
                    </div>
                  </div>
                  <div
                    style={{
                      height: "28px",
                      width: "1px",
                      backgroundColor: "#EBEBEB",
                    }}
                  ></div>
                  <div className="col-4 ms-3 d-flex flex-column align-items-start ">
                    <div className="fs-12 fw-600 cardTextGrey d-flex">
                      <div style={{ width: "50px" }}> FROM : </div>
                      <span className="fs-14 fw-400 textcolor" style={{ textAlign: "left" }}>
                        {stop.from_address ?? ""}
                      </span>
                    </div>
                    <div className="fs-12 fw-600 cardTextGrey mt-1  d-flex">
                      <div style={{ width: "50px" }}> TO : </div>
                      <span className="fs-14 fw-400 textcolor" style={{ textAlign: "left" }}>
                        {stop.to_address ?? ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-2 d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  pe-2">
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          bsPrefix="custom-toggle"
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                          style={{
                            padding: "8px 12px",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span
                              className="backgroundYellow"
                              style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "3px",
                                display: "inline-block",
                              }}
                            ></span>

                            <span className="dropdown-text textcolor fs-13 fw-500">{stop.status ?? "-"}</span>

                            {/* <span className="dropdown-toggle-arrow"></span> */}
                          </span>
                        </Dropdown.Toggle>

                        {/* <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {stageListOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option}
                              onClick={() =>
                                updateStage(stop.id, option.value)
                              }
                              // active={selected === option}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu> */}
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("edit_permission") || checkPermission("delete_permission")) && stop.status === "Created" && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {checkPermission("edit_permission") && stop.status === "Created" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/stops/create", {
                                    state: { id: stop.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && stop.status === "Created" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(stop.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/* Profile Image Modal */}
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={selectedProfile} />
    </>
  );
};
